import React from 'react';
import styled from 'styled-components';
import kindbody from 'assets/logos/kindbody.svg';
import { themes } from 'kb-shared';

const { colors, fonts } = themes;

type Props = {
  className?: string;
};

const LegalDiv = (props: Props) => {
  const { className } = props;
  const currentYear = new Date().getFullYear();

  return (
    <Container className={className}>
      <a href="https://kindbody.com/" target="_blank" rel="noopener noreferrer">
        <img src={kindbody} alt="Kindbody logo" />
      </a>
      <Text>
        <a href="https://kindbody.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="https://kindbody.com/terms-of-service/" target="_blank" rel="noopener noreferrer">
          Terms of Use
        </a>
      </Text>
      <Text>© {currentYear} Kindbody</Text>
    </Container>
  );
};

LegalDiv.defaultProps = {};

const Text = styled.div`
  &,
  && a {
    ${fonts.FoundersGrotesk};
    color: ${colors.KBNight};
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
  }
`;

const Container = styled.div`
  img,
  ${Text} {
    margin-bottom: 10px;
  }
`;

export default LegalDiv;
